
<div fxLayout="row"  fxLayoutAlign="center center">
    <a class="blueLink" (click)="confirmar=1" >Actualizar la sesion en los progresos de los alumnos</a>
</div>
<div *ngIf="confirmar===1" fxLayout="column" fxLayoutAlign="center center">
    <p>Escriba la palabra CONFIRMAR para actualizar</p>
    <div>
        <input type="text" [(ngModel)]=textoConfirmacion class="mgr10">
        <button *ngIf="textoConfirmacion==='CONFIRMAR'" class="greenButton" (click)="actualizar()">Actualizar</button>
        <button *ngIf="textoConfirmacion!=='CONFIRMAR'" class="cursorDefault">Actualizar</button>
    </div>
    <a class="blueLink" (click)="confirmar=0" class="mgt10">Cancelar</a>
</div>
    

